export const CLASS_ONBOARDING_ACTIVE = 'onboarding-active';
export const CLASS_ONBOARDING_TRIGGER = 'onboarding-trigger';
